import { StepData } from '../../model/types';

export const stepsMapper = (stepNames: string[]): StepData[] => {
  return stepNames.map((name) => ({ label: name, stepData: null }));
};
